/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-str-base[_ngcontent-%COMP%]{margin-top:2.2rem}.ng-tns-c8-11.ng-trigger.ng-trigger-animation.ng-star-inserted[_ngcontent-%COMP%]{background-color:#0099b3!important}.btn-primary[_ngcontent-%COMP%]{color:#fff!important;border-color:#0099b3!important;background-color:#0099b3!important}.btn-primary[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:focus{border-color:#0099b3!important}.modal-content[_ngcontent-%COMP%]{width:130%}"];
export { styles as styles };
